import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import '../../styles/ServiceList.css';
import axios from '../../axiosConfig';
import imgPrefix from '../../imgConfig'; // 导入 imgConfig.js
import { useTranslation } from 'react-i18next';
import { Rate } from 'antd'; // 导入Rate组件用于显示星级评分
import { fetchAvailableTechnicians } from '../../utils/technicianAvailability';


const ServiceListPage = () => {
  const { t, i18n } = useTranslation();
  const { categoryId } = useParams();
  const [services, setServices] = useState([]);
  const [technicians, setTechnicians] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const currentLang = i18n.language || 'zh';
    // 获取服务项目列表
    // 注意：categoryId 由前端路由传递的分类中文名
    const encoded = encodeURIComponent(categoryId);
    axios.get(`/jianshenxiangmu/fenlei/${encoded}?lang=${currentLang}`)
      .then((response) => {
        console.log("fenlei xiangmu", response);
        return setServices(response.data.data)})
      .catch((error) => console.error('Error fetching services:', error));
    
    const loadTechnicians = async () => {
      try {
        const availableTechnicians = await fetchAvailableTechnicians(currentLang, { limit: 5 });
        setTechnicians(availableTechnicians);
      } catch (error) {
        console.error('Error fetching technicians:', error);
        setTechnicians([]);
      }
    };

    loadTechnicians();
  }, [categoryId, i18n.language]);

  const handleServiceClick = (service) => {
    navigate(`/service/${service.id}`);
  };

  const handleBookingClick = (e, serviceId) => {
    e.stopPropagation(); // 阻止事件冒泡
    navigate(`/appointmentform?serviceId=${serviceId}`);
  };

  const handleTechnicianClick = (technicianId) => {
    navigate(`/technician/${technicianId}`);
  };

  const renderServiceTime = (service) => {
    // 根据服务类型返回不同的服务时长
    if (service.xiangmumingcheng.includes('中式推拿')) {
      return '60' + t('home.duration');
    } else if (service.xiangmumingcheng.includes('SPA')) {
      return service.xiangmumingcheng.includes('泰式') ? '90' + t('home.duration') : '70' + t('home.duration');
    }
    return '70' + t('home.duration');
  };
  
  const renderPrice = (service) => {
    // 根据服务类型返回预设价格
    if (service.xiangmumingcheng.includes('中式推拿')) {
      return '168';
    } else if (service.xiangmumingcheng.includes('精油SPA')) {
      return '268';
    } else if (service.xiangmumingcheng.includes('泰式SPA')) {
      return '368';
    }
    return service.jiage || '218';
  };

  return (
    <div className="service-list-page">
      {/* 技师轮播 */}
      <div className="more-technicians">
          {/* <span>附近技师</span>
          <span className="arrow">›</span> */}
            <img 
              src={`${imgPrefix}/upload/techicon2.6d723f9.png`} 
              // alt={technician.jiaolianxingming} 
            />
        </div>
      <div className="technician-carousel">
        {technicians.length > 0 ? (
          technicians.map((technician) => (
            <div 
              key={technician.id || technician.jiaolianbianhao} 
              className="technician-circle"
              onClick={() => handleTechnicianClick(technician.jiaolianbianhao)}
            >
              <img 
                src={`${imgPrefix}/${technician.jiaoliantupian}`} 
                alt={technician.jiaolianxingming} 
              />
            </div>
          ))
        ) : (
          <div className="technician-carousel-empty">
            {t('home.noAvailableTechnicians')}
          </div>
        )}
      </div>

      {/* 服务保障 */}
      <div className="service-guarantees">
        <div className="guarantee-item">
          <i className="guarantee-icon on-time"></i>
          <span>{t('home.guarantees.lateCompensation')}</span>
        </div>
        <div className="guarantee-item">
          <i className="guarantee-icon compensation"></i>
          <span>{t('home.guarantees.unsatisfiedRedo')}</span>
        </div>
        <div className="guarantee-item">
          <i className="guarantee-icon no-extra-fee"></i>
          <span>{t('home.guarantees.fullProtection')}</span>
        </div>
        <div className="guarantee-item">
          <i className="guarantee-icon insurance"></i>
          <span>{t('home.services')}</span>
        </div>
      </div>

      {/* 服务列表 */}
      <div className="service-items-container">
        {services.length && services.map((service) => (
          <div key={service.id} 
            className="service-item-card"
            onClick={() => handleServiceClick(service)}>
            
            <div className="service-image-container">
              <img 
                src={`${imgPrefix}/${service.xiangmutupian}`}
                alt={service.xiangmumingcheng} 
              />
              <div className="service-time-bubble">
                <span className="time-label">{t('home.duration')}</span>
                <span className="time-value">{renderServiceTime(service)}</span>
              </div>
              {service.xiangmumingcheng.includes('中式推拿') && 
                <div className="tag-purple">随缘特惠</div>
              }
            </div>
            
            <div className="service-content">
              <div>
                <div className="service-header">
                  <div className="tag-premium">{t('table.details')}</div>
                  <h3 className="service-title">
                    {/* {service.xiangmumingcheng.includes('中式推拿') ? '中式推拿' : 
                     service.xiangmumingcheng.includes('精油SPA') ? '芳香精油SPA' : 
                     service.xiangmumingcheng.includes('泰式SPA') ? '泰式SPA' : '全身推拿'} */}
                     {service.xiangmumingcheng}
                  </h3>
                </div>
                
                <div className="service-details">
                  <p className="service-duration">{t('home.duration')}：{renderServiceTime(service)}</p>
                  <p className="service-process">{t('table.details')}：仰/俯卧位(头部、肩颈、腹部、腰背...)</p>
                  <p className="fast-arrival">{t('booking.recentAppointments').replace('预约', '30')}分钟上门</p>
                </div>
              </div>
              
              <div className="service-footer">
                <div className="price-sales">
                  <div className="price">{renderPrice(service)}{t('home.price')}/次起</div>
                  <div className="sales">{Math.floor(Math.random() * 2) + 98}%</div>
                </div>
                <button 
                  className="booking-button"
                  onClick={(e) => handleBookingClick(e, service.id)}
                >
                  {t('booking.confirmBooking')}
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ServiceListPage;
